import { useDispatch, useSelector } from "react-redux";

import { TAppDispatch } from "./root.store";
import { TRootState } from "./root.reducer";

export const useAppDispatch = useDispatch.withTypes<TAppDispatch>();
export const useAppSelector = useSelector.withTypes<TRootState>();
